import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {AddressService} from '../../../../../../services/apiServices/business/address.service';
import {AddressLine} from '../../../../../../model/address-line';
import {TranslateService} from '@ngx-translate/core';
import {SearchService} from '../../../../../../services/apiServices/business/search.service';
import {AuthenticationService} from '../../../../../../services/apiServices/security/authentication.service';
import {User} from '../../../../../../model/user';

/**
 * Country to exclude (no need to add the country on the finalAddress)
 */
const COUNTRY_TO_EXCLUDE = 'FRANCE';

/**
 * Suffix KEY: Const if back-office change
 */
const COUNTRY_KEY_SUFFIX = ':NO-STATE';

/**
 * Property from Back-office
 */
const COUNTRY_LABEL_KEY = 'country';

/**
 /*
 * Correspondence between isoCode and Trigram for each country
 */
const correspondinghelper = {
  'AF': 'afg',
  'AX': 'ala',
  'AL': 'alb',
  'DZ': 'dza',
  'AS': 'asm',
  'AD': 'and',
  'AO': 'ago',
  'AI': 'aia',
  'AQ': 'ata',
  'AG': 'atg',
  'AR': 'arg',
  'AM': 'arm',
  'AW': 'abw',
  'AU': 'aus',
  'AT': 'aut',
  'AZ': 'aze',
  'BS': 'bhs',
  'BH': 'bhr',
  'BD': 'bgd',
  'BB': 'brb',
  'BY': 'blr',
  'BE': 'bel',
  'BZ': 'blz',
  'BJ': 'ben',
  'BM': 'bmu',
  'BT': 'btn',
  'BO': 'bol',
  'BA': 'bih',
  'BW': 'bwa',
  'BV': 'bvt',
  'BR': 'bra',
  'VG': 'vgb',
  'IO': 'iot',
  'BN': 'brn',
  'BG': 'bgr',
  'BF': 'bfa',
  'BI': 'bdi',
  'KH': 'khm',
  'CM': 'cmr',
  'CA': 'can',
  'CV': 'cpv',
  'KY': 'cym',
  'CF': 'caf',
  'TD': 'tcd',
  'CL': 'chl',
  'CN': 'chn',
  'HK': 'hkg',
  'MO': 'mac',
  'CX': 'cxr',
  'CC': 'cck',
  'CO': 'col',
  'KM': 'com',
  'CG': 'cog',
  'CD': 'cod',
  'CK': 'cok',
  'CR': 'cri',
  'CI': 'civ',
  'HR': 'hrv',
  'CU': 'cub',
  'CY': 'cyp',
  'CZ': 'cze',
  'DK': 'dnk',
  'DJ': 'dji',
  'DM': 'dma',
  'DO': 'dom',
  'EC': 'ecu',
  'EG': 'egy',
  'SV': 'slv',
  'GQ': 'gnq',
  'ER': 'eri',
  'EE': 'est',
  'ET': 'eth',
  'FK': 'flk',
  'FO': 'fro',
  'FJ': 'fji',
  'FI': 'fin',
  'FR': 'fra',
  'GF': 'guf',
  'PF': 'pyf',
  'TF': 'atf',
  'GA': 'gab',
  'GM': 'gmb',
  'GE': 'geo',
  'DE': 'deu',
  'GH': 'gha',
  'GI': 'gib',
  'GR': 'grc',
  'GL': 'grl',
  'GD': 'grd',
  'GP': 'glp',
  'GU': 'gum',
  'GT': 'gtm',
  'GG': 'ggy',
  'GN': 'gin',
  'GW': 'gnb',
  'GY': 'guy',
  'HT': 'hti',
  'HM': 'hmd',
  'VA': 'vat',
  'HN': 'hnd',
  'HU': 'hun',
  'IS': 'isl',
  'IN': 'ind',
  'ID': 'idn',
  'IR': 'irn',
  'IQ': 'irq',
  'IE': 'irl',
  'IM': 'imn',
  'IL': 'isr',
  'IT': 'ita',
  'JM': 'jam',
  'JP': 'jpn',
  'JE': 'jey',
  'JO': 'jor',
  'KZ': 'kaz',
  'KE': 'ken',
  'KI': 'kir',
  'KP': 'prk',
  'KR': 'kor',
  'KW': 'kwt',
  'KG': 'kgz',
  'LA': 'lao',
  'LV': 'lva',
  'LB': 'lbn',
  'LS': 'lso',
  'LR': 'lbr',
  'LY': 'lby',
  'LI': 'lie',
  'LT': 'ltu',
  'LU': 'lux',
  'MK': 'mkd',
  'MG': 'mdg',
  'MW': 'mwi',
  'MY': 'mys',
  'MV': 'mdv',
  'ML': 'mli',
  'MT': 'mlt',
  'MH': 'mhl',
  'MQ': 'mtq',
  'MR': 'mrt',
  'MU': 'mus',
  'YT': 'myt',
  'MX': 'mex',
  'FM': 'fsm',
  'MD': 'mda',
  'MC': 'mco',
  'MN': 'mng',
  'ME': 'mne',
  'MS': 'msr',
  'MA': 'mar',
  'MZ': 'moz',
  'MM': 'mmr',
  'NA': 'nam',
  'NR': 'nru',
  'NP': 'npl',
  'NL': 'nld',
  'AN': 'ant',
  'NC': 'ncl',
  'NZ': 'nzl',
  'NI': 'nic',
  'NE': 'ner',
  'NG': 'nga',
  'NU': 'niu',
  'NF': 'nfk',
  'MP': 'mnp',
  'NO': 'nor',
  'OM': 'omn',
  'PK': 'pak',
  'PW': 'plw',
  'PS': 'pse',
  'PA': 'pan',
  'PG': 'png',
  'PY': 'pry',
  'PE': 'per',
  'PH': 'phl',
  'PN': 'pcn',
  'PL': 'pol',
  'PT': 'prt',
  'PR': 'pri',
  'QA': 'qat',
  'RE': 'reu',
  'RO': 'rou',
  'RU': 'rus',
  'RW': 'rwa',
  'BL': 'blm',
  'SH': 'shn',
  'KN': 'kna',
  'LC': 'lca',
  'MF': 'maf',
  'PM': 'spm',
  'VC': 'vct',
  'WS': 'wsm',
  'SM': 'smr',
  'ST': 'stp',
  'SA': 'sau',
  'SN': 'sen',
  'RS': 'srb',
  'SC': 'syc',
  'SL': 'sle',
  'SG': 'sgp',
  'SK': 'svk',
  'SI': 'svn',
  'SB': 'slb',
  'SO': 'som',
  'ZA': 'zaf',
  'GS': 'sgs',
  'SS': 'ssd',
  'ES': 'esp',
  'LK': 'lka',
  'SD': 'sdn',
  'SR': 'sur',
  'SJ': 'sjm',
  'SZ': 'swz',
  'SE': 'swe',
  'CH': 'che',
  'SY': 'syr',
  'TW': 'twn',
  'TJ': 'tjk',
  'TZ': 'tza',
  'TH': 'tha',
  'TL': 'tls',
  'TG': 'tgo',
  'TK': 'tkl',
  'TO': 'ton',
  'TT': 'tto',
  'TN': 'tun',
  'TR': 'tur',
  'TM': 'tkm',
  'TC': 'tca',
  'TV': 'tuv',
  'UG': 'uga',
  'UA': 'ukr',
  'AE': 'are',
  'GB': 'gbr',
  'US': 'usa',
  'UM': 'umi',
  'UY': 'ury',
  'UZ': 'uzb',
  'VU': 'vut',
  'VE': 'ven',
  'VN': 'vnm',
  'VI': 'vir',
  'WF': 'wlf',
  'EH': 'esh',
  'YE': 'yem',
  'ZM': 'zmb',
  'ZW': 'zwe',
};

/**
 * Upu base link for country PDF info
 */
// const PDF_BASE_LINK = 'http://www.upu.int/fileadmin/documentsFiles/activities/addressingUnit/';
const PDF_BASE_LINK = 'https://www.upu.int/UPU/media/upu/PostalEntitiesFiles/addressingUnit/';

/**
 * Upu file extension
 */
const PDF_EXTENSION = '.pdf';

/**
 * default Lang for UPU country info
 */
const PDF_LANG = 'Fr';

/**
 * handle finalAddress format
 */
@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddressComponent implements OnInit {
  /**
   * the current fold selected by user
   */
  @Input('fold') public fold: any;
  @Input('oldAddress') public oldAddress: any;

  /**
   * here for updateOrSaveVisible purpose (modal closing)
   */
  @Output() public visible: EventEmitter<boolean>;
  @Output() public finalAddress: EventEmitter<any>;

  /**
   * the list of all countries
   */
  public countryList;

  /**
   * the selected country (inside the dropdown)
   */
  public selectedCountry: any;

  /**
   * external link for PDF description
   */
  public externalDescriptionLink: string;

  /**
   * Message gave by back when the new finalAddress setting did not worked
   */
  public errorMessage: string;

  /**
   * the properties of the selected country
   */
  public propertiesOfSelectedCountry;

  /**
   * list of each adress line (input if it should be display)
   */
  public addressesLines: AddressLine[];

  /**
   * the correct formated adress
   */
  public formatedAdress: string[];

  /**
   * message to display when a mandatory field is not complete
   */
  private mandaToryInput: string;

  /**
   * message to display when the input length's is too big
   */
  private tooLongInput: string;

  /**
   * message to display when the regex of the field is not ok
   */
  private criteraNotMatchInput: string;

  /**
   * message to display when there's not enough non mandatory fields
   */
  private notEnoughCombinationInput: string;

  /**
   * message to display when there's too much non mandatory fields
   */
  private tooMuchCombinationInput: string;

  /**
   * message to display  that give the reference (color) of the non mandatory fields that the user must change
   */
  private describtionCompinationInput: string;

  /**
   * list of draggable items (finalAddress parts) here for performance purposes (even if redundant)
   */
  public draggableItems: string[];

  /**
   * active item on dragNDrop
   */
  private dragDromItem: string;

  /**
   * current logged User
   */
  public currentUser: User;

  public addressToEdit;
  /**
   * flag to show/hide label definition modal
   */
  public displayLabelDefinition: boolean;

  /**
   * flag to show/hide button to display address definition modal
   */
  public displayAddressDefinition = false;

  /**
   * labels used to translate finalAddress items
   */
  public addressItemsLabels: any;
  public countryLabel: any;

  public addressPage = false;

  /**
   * default constructor, just instantiate variables
   *
   * @param authService to get current user info
   * @param {AddressService} addressService - here to get information for countries
   * @param {TranslateService} translate - here for translation purpose (see getTradForComponent function)
   * @param {SearchService} searchService - handle fold update on finalAddress change
   */
  constructor(private authService: AuthenticationService, private addressService: AddressService, private translate: TranslateService, private  searchService: SearchService) {
    this.countryList = [];
    this.visible = new EventEmitter<boolean>();
    this.finalAddress = new EventEmitter<any>();
    this.addressItemsLabels = {};
    this.countryLabel = {};
  }

  /**
   * init info for component
   */
  public ngOnInit(): void {
    if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
      this.addressItemsLabels = {
        country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
      };
      this.tryToBuildExistingAddress();
    }
    // noinspection JSUnusedLocalSymbols
    this.addressService.labelsReady.subscribe(val => {
      if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
        this.addressItemsLabels = {
          country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
        };
        this.tryToBuildExistingAddress();
      }
    });
    if (this.fold && this.fold.objAddrRecipient) {
      this.addressToEdit = {
        sElem: this.fold.objAddrRecipient.sElem,
        mElemByName: this.fold.objAddrRecipient.mElemByName,
        country: this.fold.sCountry
      };
    }
    else if (this.oldAddress) {
      this.addressToEdit = {
        sElem: this.oldAddress.sElem,
        mElemByName: this.oldAddress.mElemByName,
        country: this.oldAddress.country
      };
    }
    this.currentUser = this.authService.getCurrentUser();
    this.displayLabelDefinition = false;
    this.buildCountryList();
    this.getTradForComponent();
    this.buildExternalDescriptionLink();
  }

  /**
   * get finalAddress info from fold and try to handle them
   */
  private tryToBuildExistingAddress(): void {
    if (this.addressToEdit) {
      if (this.addressToEdit.sElem) {
        this.draggableItems = this.addressToEdit.sElem.filter(x => x !== this.addressToEdit.country && x.trim() !== '');
      }

      if (this.addressToEdit.mElemByName) {
        const addresProperties = this.addressToEdit.mElemByName;

        if (this.tryToGetCountryBack(addresProperties.country)) {
          this.setCountryProperties();

        }
      }
    }
  }

  /**
   * function that will (if it's possible) retrieve every non element properties inside fold finalAddress datas
   * Info: non element are fields differents from: Country/ Zip / City
   */
  private tryToBuildNonElemProperties(): void {
    if (this.addressToEdit) {
      const addresProperties = this.addressToEdit.mElemByName;
      for (const property in addresProperties) {
        if (addresProperties.hasOwnProperty(property)) {
          if (addresProperties.hasOwnProperty(property) && addresProperties[property] !== '') {
            for (const addressLine of this.addressesLines) {
              const valueFromFold = addresProperties[property];
              if (addressLine.sDataName.includes(property) && property !== COUNTRY_LABEL_KEY) {
                addressLine.sDataValue = valueFromFold;
              }

            }
          }
        }
      }
    }
  }

  /**
   * function that will (if it's possible) retrieve every element properties inside fold finalAddress datas
   * Info: element are : Country/ Zip / City
   */
  private tryToBuildElemProperties(): void {
    if (this.addressToEdit.mElemByName) {
      const addresProperties = this.addressToEdit.mElemByName;

      const regexElem = '(addrElem)[0-9]+';
      const arrayFromParam = [];

      for (const property in addresProperties) {
        if (addresProperties.hasOwnProperty(property) && addresProperties[property] !== '' && new RegExp(regexElem).test(property)) {
          arrayFromParam.push({property: property, value: addresProperties[property]});
        }
      }

      for (const addressLine of this.addressesLines) {
        for (const param of arrayFromParam) {
          if (addressLine.sDataName === param.property) {
            addressLine.sDataValue = param.value;
          }
        }

      }
    }
  }

  /**
   * function that try to determine if the fold finalAddress country is valid
   *
   * @param supposedKey - the supposed country key
   * @return {boolean} - true if a correspondence has been found
   */
  private tryToGetCountryBack(supposedKey: string): boolean {
    const correctKey = supposedKey + COUNTRY_KEY_SUFFIX;
    if (this.addressService.getPropertiesFromKey(correctKey)) {
      this.selectedCountry = correctKey;
      return true;
    } else {
      const listOfCountryNames = this.addressService.getCountriesVariousNames();
      for (const countryNames of listOfCountryNames) {
        if (countryNames.sCountryLocalName === supposedKey || countryNames.sCountryIsoName === supposedKey) {
          this.selectedCountry = countryNames.key;
          return true;
        }
      }
      return false;
    }
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('ADDRESS_COMPONENT.LABEL.GIVEN.BY.BACK.NOT_VALID_BECAUSE.MANDATORY_INPUT').subscribe((translation: string) => {
      this.mandaToryInput = translation;
    });
    this.translate.get('ADDRESS_COMPONENT.LABEL.GIVEN.BY.BACK.NOT_VALID_BECAUSE.TOO_LONG_INPUT').subscribe((translation: string) => {
      this.tooLongInput = translation;
    });
    this.translate.get('ADDRESS_COMPONENT.LABEL.GIVEN.BY.BACK.NOT_VALID_BECAUSE.CRITERIA_NOT_MATCH_INPUT').subscribe((translation: string) => {
      this.criteraNotMatchInput = translation + ': ';
    });
    this.translate.get('ADDRESS_COMPONENT.LABEL.GIVEN.BY.BACK.NOT_VALID_BECAUSE.NOT_ENOUGH_COMBINATION_INPUT').subscribe((translation: string) => {
      this.notEnoughCombinationInput = translation;
    });
    this.translate.get('ADDRESS_COMPONENT.LABEL.GIVEN.BY.BACK.NOT_VALID_BECAUSE.TOO_MUCH_COMBINATION_INPUT').subscribe((translation: string) => {
      this.tooMuchCombinationInput = translation;
    });
    this.translate.get('ADDRESS_COMPONENT.LABEL.GIVEN.BY.BACK.NOT_VALID_BECAUSE.DESCRIPTION_COMBINATION_INPUT').subscribe((translation: string) => {
      this.describtionCompinationInput = translation;
    });

  }

  /**
   * build all countries on load (fill the country list)
   */
  private buildCountryList(): void {
    const countries = this.addressService.getCountries();

    for (const country of countries) {
      this.countryList.push({label: country.label, value: country.key});
    }
  }

  /**
   * Function that build the UPU link for external application information
   */
  private buildExternalDescriptionLink(): void {
    const correspondance = this.propertiesOfSelectedCountry ? correspondinghelper[this.propertiesOfSelectedCountry.sIsoID] : undefined;
    if (correspondance) {
      this.externalDescriptionLink = PDF_BASE_LINK + correspondance + PDF_LANG + PDF_EXTENSION;
    } else {
      this.externalDescriptionLink = PDF_BASE_LINK + 'fra' + PDF_LANG + PDF_EXTENSION;
    }

  }

  /**
   * get the properties of the selected country
   */
  public setCountryProperties(): void {
    this.displayAddressDefinition = true;
    if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
      this.addressItemsLabels = {
        country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
      };
      this.buildCountryProperties();
    }
    this.addressService.labelsReady.subscribe(val => {
      if (val === this.translate.currentLang) {
        this.addressItemsLabels = {
          country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
        };
        this.buildCountryProperties();
      }
    });
  }
 buildCountryProperties() {
   this.addressesLines = [];
   this.formatedAdress = [];
   this.propertiesOfSelectedCountry = this.addressService.getPropertiesFromKey(this.selectedCountry);
   if (this.addressItemsLabels.country[this.propertiesOfSelectedCountry.sIsoID]) {
     this.countryLabel = this.addressItemsLabels.country[this.propertiesOfSelectedCountry.sIsoID];
   } else {
     this.countryLabel = {};
   }
   for (const adressLine of this.propertiesOfSelectedCountry.listFmtPostalAddr.listFmtPostalAdd) {
     const line = new AddressLine(adressLine);
     let key = line.sDataLib;
     if (key && key.indexOf('country.' + this.propertiesOfSelectedCountry.sIsoID) >= 0) {
       key = key.replace('country.' + this.propertiesOfSelectedCountry.sIsoID + '.', '');
     }
     if (this.countryLabel[key]) {
       line.sDataLibValue = this.countryLabel[key];
     }
     this.addressesLines.push(line);
   }
   this.buildExternalDescriptionLink();
   this.tryToBuildNonElemProperties();
   this.tryToBuildElemProperties();
   this.formatGlobalAdress();
 }
  /**
   * determine if the whole finalAddress seized by user is valid
   * @return {boolean} - true if it's valid
   */
  public globalFormatAdressIsValid(): boolean {
    if (this.formatedAdress) {
      let minNbLine;
      const maxNbLine = this.propertiesOfSelectedCountry.iNbMaxLines;

      if (this.propertiesOfSelectedCountry.sCountryIsoName === COUNTRY_TO_EXCLUDE) {
        minNbLine = this.propertiesOfSelectedCountry.iNbMinLines;
      } else {
        minNbLine = this.propertiesOfSelectedCountry.iNbMinLines + 1;
      }

      if (this.formatedAdress.length >= minNbLine && this.formatedAdress.length <= maxNbLine) {
        for (const adressLine of this.addressesLines) {
          if (!adressLine.isInputValid()) {
            return false;
          }
        }
        return true;
      }
    }
    return false;

  }

  /**
   * function that fill formatedAdress.
   * Keep in mind that the order inside a formatted line depends on the order given by the server.
   * Carefull: iLineDataIndex is not used
   */
  public formatGlobalAdress(): void {
    this.formatedAdress = [];

    const tempoArray = [];

    for (const addressLine of this.addressesLines) {
      const index = addressLine.iLineNumber - 1;
      if (addressLine.sDataValue) {
        if (tempoArray[index]) {
          tempoArray[index] = tempoArray[index].concat(addressLine.sDataValue);
        } else {
          tempoArray[index] = addressLine.sDataValue;
        }
      }
    }

    for (const entry of tempoArray) {
      // Specific case: for france (we're not adding the country to the finalAddress)
      if (entry && entry !== COUNTRY_TO_EXCLUDE) {
        this.formatedAdress.push(entry);
      }

    }
  }

  /**
   * determine the reason why the input is not ok
   * @param {AddressLine} addressLine - the finalAddress that is not correct
   * @return {string} - the reason
   */
  public getReasonWhyInputIsNotValid(addressLine: AddressLine): string {
    if (addressLine.sDataValue.length > addressLine.sDataLengthMax) {
      return this.tooLongInput;
    }
    if (!new RegExp(addressLine.sControlFmt).test(addressLine.sDataValue)) {
      return this.criteraNotMatchInput + ' ' + addressLine.sControlFmt;
    }
    if (addressLine.sDataValue.length === 0) {
      return this.mandaToryInput;
    }
    return '';
  }

  /**
   * determine the reason why the combination of non mandatory field is not ok
   * @return {string} - the reason
   */
  public getReasonWhyCombinationIsNotValid(): string {
    const numberOfNonMandatoryPending =
      this.propertiesOfSelectedCountry.iNbMinLines -
      this.getNumberOFromMandatoryInput() -
      this.getNumberOfNonMandatorySeizedInput();

    if (numberOfNonMandatoryPending > 0) {
      return this.notEnoughCombinationInput + ' ' + numberOfNonMandatoryPending + ' ' + this.describtionCompinationInput;
    } else if (numberOfNonMandatoryPending < 0) {
      return this.tooMuchCombinationInput + ' ' + Math.abs(numberOfNonMandatoryPending) + ' ' + this.describtionCompinationInput;
    }
    return '';
  }

  /**
   * determine if the number of non mandatory input seized by user is ok
   * @return {boolean}
   */
  public numberOfNonMandatoryFieldIsOk(): boolean {
    const minimum = this.propertiesOfSelectedCountry.iNbMinLines - this.getNumberOFromMandatoryInput();
    const maximum = this.propertiesOfSelectedCountry.iNbMaxLines - this.getNumberOFromMandatoryInput();

    return this.getNumberOfNonMandatorySeizedInput() - minimum >= 0 && this.getNumberOfNonMandatorySeizedInput() - maximum <= 0;
  }

  /**
   * function that return the number of line that should be produced by mandatory input
   * /_!_\ the -1 is there so that the country will not be counted /_!_\
   * @return {number}
   */
  private getNumberOFromMandatoryInput(): number {
    const tempArray = [];
    for (const addressLine of this.addressesLines) {
      if (addressLine.bDataMandatory) {
        tempArray.push(addressLine.iLineNumber);
      }
    }
    return Array.from(new Set(tempArray)).length - 1;
  }

  /**
   * function that return the number of line already produced by non-mandatory input
   * @return {number}
   */
  private getNumberOfNonMandatorySeizedInput(): number {
    const tempArray = [];

    for (const addressLine of this.addressesLines) {
      if (!addressLine.bDataMandatory && addressLine.sDataValue !== '') {
        tempArray.push(addressLine.iLineNumber);
      }
    }
    return Array.from(new Set(tempArray)).length;
  }

  /**
   * function that'll handle setting new finalAddress request consequences
   */
  public setNewAddress(): void {
    this.errorMessage = null;
    if (this.fold && this.fold.serialSent) {
      this.addressService.sendAddress(this.addressesLines, this.propertiesOfSelectedCountry.sIsoID, this.fold.serialSent, this.addressPage).subscribe(response => {
        if (response.body.bOK) {

          // noinspection JSUnusedLocalSymbols
          this.searchService.performLastSearch().subscribe(res => {
            this.closeComponent();
          });
        } else {
          this.errorMessage = response.sMsgError;
        }
      });
    }
    else {
      this.closeComponent();
    }
  }
  public triggerLabelDefinition(visibility: boolean): void {
    if (!visibility) {
      if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
        this.addressItemsLabels = {
          country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
        };
        this.displayLabelDefinition = visibility;
      }
      else {
        this.addressService.labelsReady.subscribe(val => {
          if (val === this.translate.currentLang) {
            this.addressItemsLabels = {
              country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
            };
            this.displayLabelDefinition = visibility;
          }
        });
      }
    }
    else {
      this.displayLabelDefinition = visibility;
    }
  }
  /**
   * spread information about the modal closure to the parent component
   */
  public closeComponent(): void {
    if (!this.fold) {
      this.finalAddress.emit({country: this.selectedCountry, fa: this.formatedAdress, lines: this.addressesLines});
    }
    this.visible.emit(false);
  }

  /**
   * set selected element on Drag event
   * @param {string} selectedElement - the active dragged element
   */
  public setDragDropElem(selectedElement: string): void {
    this.dragDromItem = selectedElement;
  }

  /**
   * put dropped selectedElement into model
   * @param {number} refValue - index of the addressesLines where the selectedElement was dropped
   */
  public getDragDropElem(refValue: number): void {
    this.addressesLines[refValue].sDataValue = this.addressesLines[refValue].sDataValue.concat(' ' + this.dragDromItem);

    this.formatGlobalAdress();
  }

  /**
   * reset content of an input addressLine field
   * @param {number} refValue -  index of the addressesLines that needs to be flush
   */
  public clearInputField(refValue: number): void {
    this.addressesLines[refValue].sDataValue = '';
    this.formatGlobalAdress();
  }
}
